import { render, staticRenderFns } from "./UiPageTopBar.vue?vue&type=template&id=bdec51a4&scoped=true&"
import script from "./UiPageTopBar.vue?vue&type=script&lang=js&"
export * from "./UiPageTopBar.vue?vue&type=script&lang=js&"
import style0 from "./UiPageTopBar.vue?vue&type=style&index=0&id=bdec51a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdec51a4",
  null
  
)

export default component.exports